import { config } from 'app/config/config';
import { i18n } from 'app/i18n';
import { HouseType } from 'app/pages/order/model/house-type';
import { NavigationService } from 'app/services/navigation-service';

interface Breadcrumb {
    text: string;
    path: string;
}

interface Breadcrumbs {
    externalBreadcrumbs: Breadcrumb[];
    internalBreadcrumbs: Breadcrumb[];
}

class BreadcrumbUtils {
    public static getBreadcrumbs = (path: string, houseType: HouseType, hideProductDetails: boolean): Breadcrumbs => ({
        externalBreadcrumbs: [
            {
                text: i18n.components.breadcrumb.myPages,
                path: config.MY_PAGES_URL,
            },
        ],
        internalBreadcrumbs: BreadcrumbUtils.getInternalBreadcrumbs(path, houseType, hideProductDetails),
    });

    public static getInternalBreadcrumbs = (
        path: string,
        houseType: HouseType,
        hideProductDetails: boolean,
    ): Breadcrumb[] => {
        const breadcrumbs: Breadcrumb[] = [
            {
                path: NavigationService.HOUSING_SELECT,
                text: i18n.components.breadcrumb.housingSelect,
            },
            ...(!hideProductDetails
                ? [
                      {
                          path: NavigationService.PRODUCT_DETAILS,
                          text: i18n.components.breadcrumb.productDetails[houseType],
                      },
                  ]
                : []),
            {
                path: NavigationService.SUMMARY,
                text: i18n.components.breadcrumb.productSummary,
            },
        ];

        const currentBreadcrumbIndex = breadcrumbs.findIndex((element) => element.path === path);

        return breadcrumbs.slice(0, currentBreadcrumbIndex + 1);
    };

    public static isFirstInternalBreadcrumb = (path: string, breadcrumbs: Breadcrumb[]): boolean =>
        breadcrumbs[0].path === path;

    public static getPreviousBreadcrumbPath = (path: string, breadcrumbs: Breadcrumb[]): string =>
        breadcrumbs[breadcrumbs.findIndex((breadcrumb) => breadcrumb.path === path) - 1].path;
}

export { BreadcrumbUtils };
